import React from "react";

import { Modal } from "../../../core";
import AddYarnQualityForm from "../../../views/settings/AddYarnQualityForm";

const AddYarnQuality = ({
  addyarnQaulityModal,
  getYarnQualities,
  closeModal,
}) => {
  return (
    <Modal
      closable={true}
      visible={addyarnQaulityModal}
      okText="Add"
      maxwidth="568px"
      footer={false}
      onCancel={closeModal}
      tittle="Add Yarn Quality"
    >
      <AddYarnQualityForm
        getYarnQualities={getYarnQualities}
        closeModal={closeModal}
      />
    </Modal>
  );
};

export default AddYarnQuality;
